<app-carousel *ngIf="banners.length" [slides]="banners"></app-carousel>
<img [src]="'../assets/images/banner01.jpg'" [title]="'Image'" class="w-100" alt="" *ngIf="banners.length == 0"/>

<section class="brand-slider px-3" *ngIf="brands.length">
  <p-carousel [value]="brands" [numVisible]="12" [numScroll]="4" [circular]="true" [responsiveOptions]="brandOptions" autoplayInterval="3000" [showNavigators]="false">
    <ng-template let-brand pTemplate="item">
      <app-brands [brand]="brand"></app-brands>
    </ng-template>
  </p-carousel>
</section>

<div class="products-container mb-md-5 mb-2">
  <div *ngIf="isFetchingListings" class="loader-container d-flex flex-column">
    <div class="d-flex justify-content-center align-items-center mt-5 py-4 mb-2 ">
      <div class="spinner-border text-danger" role="status" style="width: 4rem; height: 4rem;">
        <span class="visually-hidden">Loading...</span>
      </div>
    </div>
    <div class="fw-bold mb-5">Loading....</div>
  </div>
  <section class="mb-5" *ngIf="webListings.length">
    <div *ngFor="let listing of webListings">
      <!-- Category Heading -->
      <div class="product-header px-md-4 px-1 py-1  text-danger" *ngIf="listing.fofoCatalogResponses.length > 0">
        <div class="d-flex px-2 justify-content-between align-items-center py-2">
          <!-- Product Title -->
          <h2 class="product-title mb-0 fs-lg-1 text-danger text-decoration-underline">
            {{ listing.title }}
          </h2>

          <!-- View All Button -->
          <button
            class="btn btn-outline-light view-all-btn text-danger"
            role="button"
            (click)="navigateToPage(listing.url)">
            View All
          </button>
        </div>
      </div>

      <!-- Carousel for Products -->
      <div class="px-md-3">
       <p-carousel
         *ngIf="listing.fofoCatalogResponses.length > 0"
         [value]="listing.fofoCatalogResponses"
         [numVisible]="5"
         [numScroll]="2"
         [circular]="true"
         [responsiveOptions]="responsiveOptions"
         [showNavigators]="false"
       >
         <ng-template let-product pTemplate="item">
           <app-product [product]="product"></app-product>
         </ng-template>
       </p-carousel>
      </div>
    </div>
  </section>
</div>

<p-dialog [(visible)]="welcomeDialog">
  <ng-template pTemplate="headless">
    <span class="close-franchise-dialog" (click)="closeDialog()">X</span>
    <div class="flex flex-column px-8 py-5 gap-4 franchise-dialog">
      <a href="javascript:void(0)" (click)="openUrl('https://franchise.smartdukaan.com/#join')" class="btn btn-danger franchise-btn">Became Franchise Partner</a>
    </div>
  </ng-template>
</p-dialog>
